import { toast } from "vue3-toastify";
import { h } from "vue";
import CustomStyledToast from "@/components/toast.vue";

export const notify = (message) => {
  toast(
    h(CustomStyledToast, {
      message,
    }),
    {
      props: {
        message,
      },
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
    }
  );
};
